module.exports = __webpack_public_path__ + "img/emc.e531e2b8.svg";